export default "__VITE_ASSET__806bb004__"